var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"h-100",attrs:{"loading":_vm.isLoading}},[_c('v-card-title',[_vm._t("title")],2),_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }